/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import GeneralControllers from './GeneralControllers';
import StyleControllers from './StyleControllers';

const Controllers = ({
  handle,
  config,
  data,
  extend,
  setExtend,
  selectedColumn,
  selectedFunction,
}) => (
  <>
    {[GeneralControllers, StyleControllers].map((Group) => (
      <Group
        key={Group.name}
        handle={handle}
        config={config}
        data={data}
        extend={extend}
        setExtend={setExtend}
        selectedColumn={selectedColumn}
        selectedFunction={selectedFunction}
      />
    ))}
  </>
);

Controllers.propTypes = {
  config: PropTypes.objectOf(PropTypes.any),
  data: PropTypes.objectOf(PropTypes.any),
  selectedColumn: PropTypes.objectOf(PropTypes.any),
  selectedFunction: PropTypes.objectOf(PropTypes.any),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
};

Controllers.defaultProps = {
  config: undefined,
  data: undefined,
  selectedColumn: undefined,
  selectedFunction: undefined,
  handle: () => {},
  extend: '',
  setExtend: () => {},
};

export default Controllers;
